export const isMobileDevice = () => {
    const moblieDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return moblieDevice || (window.matchMedia("(max-width: 767px)").matches && window.matchMedia("(min-height: 450px)").matches);
};
